import {useReactFlow, XYPosition} from '@xyflow/react';
import {PopoverContextMenu, UsePopoverContextMenuReturn} from '../components/popover-context-menu';
import {useMemo} from 'react';
import useWorkflowStore from './store';

export const WorkflowContextMenu = ({
  popoverContextMenu,
  // openNodeCreateDialog, // openCreateDialog is passed from workflow.tsx, in admin/pages/resources/projects/workflow/workflow.tsx, line 33
}: {
  popoverContextMenu: UsePopoverContextMenuReturn;
  // openNodeCreateDialog?: (nodeType: string, position: XYPosition) => void; // openCreateDialog is passed from workflow.tsx, in admin/pages/resources/projects/workflow/workflow.tsx, line 33
}) => {
  const {screenToFlowPosition, addNodes} = useReactFlow();
  const {anchor} = popoverContextMenu;
  const {dialogState} = useWorkflowStore();

  const position = useMemo(() => {
    return screenToFlowPosition({
      x: anchor?.x || 0,
      y: anchor?.y || 0,
    });
  }, [screenToFlowPosition, anchor]);

  const contextMenuItems = useMemo(
    () => [
      {
        id: 'addTask',
        label: 'Thêm công việc',
        onClick(m) {
          dialogState.createNode?.openDialog({type: 'task', position});
          // openNodeCreateDialog?.('task', position);
        },
      },
      // {
      //   id: 'addMilestone',
      //   label: 'Thêm mốc',
      // },
      // {
      //   id: 'addLabel',
      //   label: 'Thêm nhãn',
      // },
    ],
    [addNodes, position],
  );

  return <PopoverContextMenu title="" menuItems={contextMenuItems} {...popoverContextMenu} />;
};
